import { CHOOSE_DOUBLE_REWARDS_CAMPAIGN_TAG } from '../loyaltyChooseDoubleRewardsTakeover.constants'
import { isValidDate } from 'lib/datetime/dateUtils'
import { readEnabledFeatureFlagPayload, readTrimmedString, readTrimmedStringArray } from 'loyalty/lib/labPayloadUtils'
import { createSelector } from 'reselect'
import type { ChooseDoubleRewardsCampaignMetadata } from './loyaltyChooseDoubleRewardsState'

export function resolveLoyaltyChooseDoubleRewardsMetadata(
  flag: App.LabFeatureFlagResult | undefined,
): ChooseDoubleRewardsCampaignMetadata | undefined {
  const payload = readEnabledFeatureFlagPayload(flag)

  const decisionGroup = readTrimmedString(payload?.decisionGroup)
  const doublePointsChoiceId = readTrimmedString(payload?.doublePointsChoiceId)
  const doubleStatusCreditsChoiceId = readTrimmedString(payload?.doubleStatusCreditsChoiceId)
  const campaignEndDateString = readTrimmedString(payload?.campaignEndDate)
  const campaignEndDate = campaignEndDateString ? new Date(campaignEndDateString) : undefined
  const supportedProductTypes = readTrimmedStringArray(payload?.supportedProductTypes)

  if (
    !decisionGroup ||
    !doublePointsChoiceId ||
    !doubleStatusCreditsChoiceId ||
    doublePointsChoiceId === doubleStatusCreditsChoiceId ||
    !supportedProductTypes?.length ||
    !campaignEndDate ||
    !isValidDate(campaignEndDate)) {
    return undefined
  }
  return {
    decisionGroup,
    doublePointsChoiceId,
    doubleStatusCreditsChoiceId,
    endsAt: campaignEndDate,
    supportedProductTypes,
  }
}

/** For memoization across callers */
const getParsedMetadata = createSelector(
  (metadataFlag: App.LabFeatureFlagResult | undefined) => metadataFlag,
  resolveLoyaltyChooseDoubleRewardsMetadata,
)

/**
 * @returns boolean - true if offer is either in supported product types or has the campaign tag
 */
export function matchesLoyaltyDoubleRewardsOfferCriteria(
  offer: {
    type?: App.OfferType,
    campaignTags?: Array<string>
  },
  metadataFlag: App.LabFeatureFlagResult | undefined,
): boolean {
  const metadata = getParsedMetadata(metadataFlag)
  if (!metadata) return false

  const matchesOfferType = !!offer.type && metadata.supportedProductTypes.includes(offer.type)
  const matchesCampaignTag = !!offer.campaignTags?.includes(CHOOSE_DOUBLE_REWARDS_CAMPAIGN_TAG)

  return matchesOfferType || matchesCampaignTag
}
